import { useState, useEffect, Fragment } from "react";

import styled from '@emotion/styled';
import { css } from '@emotion/react';

import ManageHistoryRoundedIcon from '@mui/icons-material/ManageHistoryRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import ArrowBack from '@mui/icons-material/ArrowBack';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import LibraryAddCheckRoundedIcon from '@mui/icons-material/LibraryAddCheckRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import QrCodeScannerRoundedIcon from '@mui/icons-material/QrCodeScannerRounded';
import SellRoundedIcon from '@mui/icons-material/SellRounded';
import NextPlanRoundedIcon from '@mui/icons-material/NextPlanRounded';
import TodayRoundedIcon from '@mui/icons-material/TodayRounded';

import { IconButton, Badge, Tooltip, useTheme, alpha, lighten, Card, CardHeader, CardContent, Divider, CardActions, Button, TextField, ToggleButtonGroup, ToggleButton, Tab, Tabs, AppBar, Paper } from "@mui/material";

import ErrorMessage from "../../../utils/MuiFields/ErrorMessage";

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from "../../../utils/utilities/CardComponents";

import BooleanChip from "../../../utils/utilities/BooleanChip";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import useSnackbarStore from "../../../store/snackbar";

import { displayLabelWig } from "../../../utils/displayLabels";

// get scheduled tickets
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getScheduledTickets, getTicketById, checkInWig } from "../../Service_Tickets/apiService";

import { BasicFlex, ScrollableContainer } from '../../../utils/Common';

import BasicSideDrawer from '../../../utils/utilities/SideDrawer';

import TimelineWithComments from "../../../utils/utilities/Timeline/TimelineWithComments";

import NoItems from "../../../utils/NoItems";

import { formatGenericDateTime, relativeTime } from "../../../utils/util";

import { Formik, Form } from 'formik';

import Field from "../../../utils/FormikFields/Field";

import FileDownloader from "../../../utils/FileDownloader";

import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";

import { FormDataContext } from "../../../contexts/FormData";

import useSimpleTable from "../../../hooks/useSimpleTable";

import SearchInput from "../../../utils/utilities/SearchInput";

import * as Yup from 'yup';
import App from "../../../App";

const NoItemsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50%;
  /* border: 2px dashed ${props => props.theme.colors.border}; */
  /* padding: 1.6rem; */
  /* border-radius: 8px; */
` 

const ListHeader = styled.div`
  font-size: 1.2rem;
  margin-bottom: .3rem;
  font-weight: 500;
  color: ${props => props.theme.colors.mildText};
  text-align: right;
`;

const TicketList = styled(ScrollableContainer)`
  border: none;
  border-radius: 8px;
  padding: .8rem .5rem;
  background-color: #eee;
  min-height: calc(100vh - 18rem);
  max-height: calc(100vh - 18rem);
  /* margin-top: 1rem; */
`

const FormTitle = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${props => props.theme.colors.mildText};
`;

const FormField = styled.div`
  width: 100%;
`;

const FormFields = styled(BasicFlex)`
  gap: 1rem;
  margin: 2rem 0;
`;

const SearchContainer = styled.div`
  max-height: 5rem;
  margin: 1.2rem 0;
  margin-bottom: .5rem;
` 

const ScheduledServiceCardStyles = styled(Card)`
  ${props => !props.$selected ? css`
    cursor: pointer;
    background-color: ${props.theme.colors.lightBg};

    &:hover {
      background-color: ${props.theme.colors.secondaryFaint};
    }
  ` : css`
    /* background-color: ${props.theme.colors.lightBg}; */
  `}
`;

const ScheduledServiceCard = ({ service_ticket = {}, selectTicket, selected = false }) => {
  const theme = useTheme();

  const queryClient = useQueryClient();

  const[formValues, setFormValues] = useState({
    inventory_id: "",
  });

  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);

  const { data: ticket = service_ticket } = useQuery({
    queryKey: ['service_tickets', service_ticket.service_ticket_id],
    queryFn: () => getTicketById(service_ticket.service_ticket_id),
    enabled: !!service_ticket.service_ticket_id && selected
  })

  console.log(ticket, "!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")

  useEffect(() => {
    if (ticket) {
      setFormValues({
        inventory_id: ticket.inventory_id
      });
    }
  }, [ticket])

  const { mutate} = useMutation({
    mutationFn: ({ ...values }) => {
      return checkInWig({...values})
    },
    onSuccess: () => {
      showSnackbar('Checked in successfully!', 'success');
      queryClient.invalidateQueries(['service_tickets'])
    }
  })

  const handleCheckIn = (userInfo, { setSubmitting, setErrors} ) => {
    mutate({...userInfo, ...formValues, service_ticket_id: service_ticket.service_ticket_id})
  }

  const checkInSchema = Yup.object().shape({
    wig_id: Yup.string().required('Wig ID is required'),
    notes: Yup.string(),
  });

  const downloadFile = async (service_ticket_id) => {
    let fileDownloader = new FileDownloader();
    // setLoadingTickets(prev => ({ ...prev, [service_ticket_id]: true })); // Start loading
    try {
      await fileDownloader.downloadAndDisplayPdf(`/service_tickets/generate/slip/${service_ticket_id}?generate=qrcode`, "service ticket", "", "application/pdf");
    } catch (e) {
      console.log(e);
    } finally {
      // setLoadingTickets(prev => ({ ...prev, [service_ticket_id]: false }));
    }
  }

  const mainInfoBlock = [
    {
      header: "", icon: <SettingsSuggestOutlinedIcon fontSize='small' color="icon" />, info: <SimpleChip label={ticket.service_name} />, spread: "1rem", dataType: "text"
    },
    {
      header: "", icon: <AccountBoxRoundedIcon fontSize='small' color="icon" />, info: ticket.client_name, spread: "1rem", dataType: "text"
    },
    {
      header: "", icon: <CalendarMonthRoundedIcon fontSize='small' color="icon" />, info: formatGenericDateTime(ticket?.scheduled_date, "long"), spread: "1rem"
    },
    // {
    //   header: "", icon: <AccountBoxRoundedIcon fontSize='small' color="icon" />, info: ticket.stylist_id, spread: "1rem", dataType: "phone"
    // }
    {
      header: "Scheduled Dropoff", info: relativeTime(ticket?.scheduled_check_in_at), spread: "1rem"
    }
  ]

  const checkedInBlock = [
    {
      header: "Checked In At", icon: <CalendarMonthRoundedIcon fontSize='small' color="icon" />, info: formatGenericDateTime(ticket?.checked_in_at, "long"), spread: "1rem"
    },
    {
      header: "Wig ID", icon: <SellRoundedIcon fontSize='small' color="icon" />, info: ticket?.wig_id, spread: "1rem", dataType: "text"
    }
  ]

  return (
    <FormDataContext.Provider value={{formValues, setFormValues}}>
      <Formik
        initialValues={{
          wig_id: ticket?.wig_id || "",
          notes: ""
        }}
        enableReinitialize
        onSubmit={handleCheckIn}
        validationSchema={checkInSchema}
      >
        {(formikBag) => (

        <Form style={{width: "100%"}}>
            
    <ScheduledServiceCardStyles variant="outlined" sx={{width: "100%"}} onClick={() => selectTicket(ticket)} $selected={selected}>
       
      <CardHeader 
        title={<BasicFlex justify="flex-start" gap=".5rem">
          <SellRoundedIcon fontSize="small" color="basic"  />Service Ticket #{ticket?.service_ticket_num}
          </BasicFlex>} 
        sx={{p: selected ? 2 : 1}} 
        slotProps={{title: {sx: {fontSize: "1.4rem"}}, subheader: {sx: {fontSize: "1.2rem"}}, action: {sx: {mr: ".6rem", mt: ".1rem"}}}} 
        subheader={<BasicFlex justify="flex-start" gap=".5rem">
          {/* Scheduled Dropoff: {relativeTime(ticket?.scheduled_date, "long")} */}
          </BasicFlex>} 
        action={<BooleanChip check={ticket?.status === "checked_in"} values={["Checked In", "Scheduled"]} />} 
      />
      <Divider />
      <CardContent sx={{p: selected ? 2 : 1, paddingBottom: '1rem !important'}}>
       <CardBlockContainer $gap=".8rem">
        {selected ? <CardBlockHeader>Details</CardBlockHeader> : null}
          {mainInfoBlock.map((block, index) => (
            <CardBlock key={index} {...block} />
          ))}
        </CardBlockContainer>
        {selected ? (
            <>
              {ticket?.status !== "checked_in" ? <FormFields dir="column">
                <FormTitle>Add Additional Details</FormTitle>
                <FormField>
                <AutoCompleteSolo 
                  name="wig_id" 
                  fieldName="wig_id"
                  placeholder="Wig ID (If NA, add short description)" 
                  simple={true}
                  url="inventory"
                  conditionStr={`&customer_id[$eq]=${ticket?.customer_id}`} 
                  displayLabel={displayLabelWig}
                  formUpdates={[{name: "inventory_id", field: "inventory_id"}]}
                />
                </FormField>
                <Field component={TextField} placeholder="Notes" multiline fullWidth size="small" minRows={2} name="notes"/>
              </FormFields> : <CardBlockContainer $gap=".8rem">
                <CardSpacer />
                <CardBlockHeader>Additional Info</CardBlockHeader>
                {checkedInBlock.map((block, index) => (
                  <CardBlock key={index} {...block} />
                ))}
              </CardBlockContainer>}
              {/* <TimelineWithComments title="History & Comments" events={[]} /> */}
            </>
        ) : null}
      </CardContent>

      {selected ? (
        <Fragment>
          <Divider />
          <CardActions sx={{p: selected ? 2 : 1}}>
            {ticket?.status !== "checked_in" ? <Button startIcon={<SendRoundedIcon />} disabled size="small" variant="outlined" color="secondary" fullWidth>SMS Reminder</Button> : null }
            {ticket?.status !== "checked_in" ? <Button startIcon={<LibraryAddCheckRoundedIcon />} size="small" variant="contained" fullWidth onClick={() => formikBag.submitForm(formikBag.values, formikBag)}>Check In</Button> : null}
            {ticket?.status === "checked_in" ? <Button startIcon={<QrCodeScannerRoundedIcon />} variant="contained" fullWidth onClick={() => downloadFile(ticket?.service_ticket_id)}>Print Ticket</Button> : null}
          </CardActions>
        </Fragment>
      ) : null}
       
    </ScheduledServiceCardStyles>
     </Form>
    )}
    </Formik>
    </FormDataContext.Provider>
  )
};

const SideDrawer = ({ expand, setExpand }) => {
  const [ticket, setTicket] = useState(null);

  const [ period, setPeriod ] = useState("today"); // today or upcoming
  
  const { data: tickets } = useQuery({
    queryKey: ['appointments', 'service_tickets', period],
    queryFn: () => getScheduledTickets(period),
    enabled: expand
  })

  const { data: service_tickets, pagination, setPagination, setSearchTerm } = useSimpleTable({localData: tickets, rowsPerPage: 200, searchFields: ["client_name"], defaultSort: "scheduled_date"});

  return (
    <BasicSideDrawer open={expand} title="Scheduled Dropoffs" handleClose={() => {
      setExpand(false)
      setTicket(null)
    }}
    >
      {ticket ? <Button startIcon={<ArrowBack />} onClick={() => setTicket(null)} color="secondary" sx={{width: "fit-content", my: "1rem"}}>Back to list</Button> : null }

      {!ticket ? <>
      <Paper elevation={2} sx={{mt: ".5rem", pb: "0" }} square>
        <Tabs value={period} onChange={(e, newValue) => setPeriod(newValue)} sx={{pb: "0"}} variant="fullWidth">
          <Tab label="Today" value="today" icon={<TodayRoundedIcon />} iconPosition="start" sx={{pb: "0", minHeight: "auto"}} />
          <Tab label="Upcoming" icon={<NextPlanRoundedIcon />} iconPosition="start" value="upcoming" sx={{pb: "0", minHeight: "auto"}}  />
        </Tabs>
      </Paper>
      <SearchContainer>
      <SearchInput onChange={(e) => setSearchTerm(e.target.value)} fieldsToSearch={["Customer"]} />
      </SearchContainer>
      <ListHeader>
        {service_tickets?.rows?.length} Tickets
      </ListHeader>
      <TicketList>
        <BasicFlex dir="column" gap="1rem">
          {service_tickets?.rows?.length ? service_tickets?.rows?.map(st => <ScheduledServiceCard key={st.service_ticket_id} service_ticket={st} selectTicket={setTicket} />) : <NoItemsContainer><NoItems title="No Scheduled Wigs" /></NoItemsContainer>}
        </BasicFlex>
      </TicketList>
      </> : null}

      {ticket ? <ScheduledServiceCard key={ticket.service_ticket_id} service_ticket={ticket} selectTicket={setTicket} selected={true} /> : null}
    </BasicSideDrawer>
  )
}

const Scheduled = () => {
  const [expand, setExpand] = useState(false);
  const theme = useTheme();
  return (
    <Fragment>
    <Tooltip title="Scheduled Wigs">
      <IconButton onClick={() => setExpand(true)} color="secondary" sx={{backgroundColor: alpha(theme.palette.secondary.main, 0.1)}}>
        <Badge color="error" badgeContent={0}>
          <FactCheckRoundedIcon />
        </Badge>
      </IconButton>
    </Tooltip>
    <SideDrawer expand={expand} setExpand={setExpand} />
    </Fragment>
  )
};

export default Scheduled;